import React from 'react';
import { Row, Col, Typography, Form, Input, Button, Divider, message, Spin } from 'antd';
import { useUser } from './hooks/useUserState';
import { changePassword } from '../../services/authService';
import { useAuth } from '../../auth/AuthContext';

const ProfileSettings = () => {
  const { Title, Text } = Typography;
  const [form] = Form.useForm();
  const { user, loading } = useUser();
  const userAuth = useAuth();

  const handlePasswordChange = async (values) => {
    const { new_password, confirm_password } = values;
    if (new_password !== confirm_password) {
      message.error('New password and confirmation do not match.');
      return;
    }

    try {
      await changePassword(values);
      form.resetFields();
      message.success('Password changed successfully. Kindly login again...', 5);
      userAuth.logout();
    } catch (err) {
      const responseError = err?.response?.data?.error?.message;
      if (responseError) {
          message.error(responseError);
      } else {
          message.error(err.message || 'Failed to change password');
      }
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <Spin tip="Loading profile..." />
      </div>
    );
  }

  return (
      <div>
          <Row>
              <Col xs={24} md={6}>
                  <Title level={5}>Profile Information</Title>
              </Col>
              <Col>
                  <div className="mb-16">
                      <Text strong>Full Name:</Text>
                      <div>{user?.name}</div>
                  </div>
                  <div className="mb-16">
                      <Text strong>Email:</Text>
                      <div>{user?.email}</div>
                  </div>
              </Col>
          </Row>
          <Divider />
          <Row>
              <Col xs={24} md={6}>
                  <Title level={5}>Change Password</Title>
              </Col>
              <Col xs={24} md={18}>
                  <Form form={form} layout="vertical" onFinish={handlePasswordChange} style={{maxWidth: 400}}>
                      <Form.Item
                          label="Current Password"
                          name="old_password"
                          rules={[{ required: true, message: 'Please enter your current password' }]}
                      >
                          <Input.Password />
                      </Form.Item>

                      <Form.Item
                          label="New Password"
                          name="new_password"
                          rules={[{ required: true, min: 6, message: 'Password must be at least 6 characters' }]}
                      >
                          <Input.Password />
                      </Form.Item>

                      <Form.Item
                          label="Confirm New Password"
                          name="confirm_password"
                          dependencies={['new_password']}
                          rules={[
                              { required: true, message: 'Please confirm your new password' },
                              ({ getFieldValue }) => ({
                                  validator(_, value) {
                                      if (!value || getFieldValue('new_password') === value) {
                                          return Promise.resolve();
                                      }
                                      return Promise.reject(new Error('Passwords do not match'));
                                  },
                              }),
                          ]}
                      >
                          <Input.Password />
                      </Form.Item>

                      <Form.Item>
                          <Button type="primary" htmlType="submit">
                              Change Password
                          </Button>
                      </Form.Item>
                  </Form>
              </Col>
          </Row>
      </div>
  );
};

export default ProfileSettings;
